export const addLeadingZeros = (num: number, amountOfZeros: number) =>
  String(num).padStart(amountOfZeros, '0');

export const createLeadingZerosFn = (amountOfZeros: number) => (num: number) =>
  addLeadingZeros(num, amountOfZeros);
